var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":_vm.backg,"current-page":_vm.currentPage,"page-sizes":_vm.pageSizeOption,"page-size":_vm.pageSize,"layout":_vm.layoutConfig,"total":_vm.total},on:{"size-change":_vm.pageSizeChange,"current-change":_vm.currentPageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }